import styled from 'styled-components';

interface CardProps {
	type: 'PAUSE' | 'RESUME' | 'FINALIZED';
}

export const Card = styled.article<CardProps>`
	align-content: center;
	background-color: ${({ theme, type }) =>
		type === 'PAUSE'
			? theme.colors.extra.saturn_100
			: type === 'RESUME'
			? theme.colors.extra.success_100
			: theme.colors.extra.error_100};
	display: flex;
	flex-direction: column;
	gap: 16px;
	justify-content: center;
	max-width: 420px;
	min-width: 341px;
	padding: 32px 40px;
	text-align: center;
	width: 100%;
`;

export const CardHeader = styled.header`
	align-content: center;
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;

	svg {
		height: 62px;
		width: 62px;
	}
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	text-align: center;
`;

export const CardTitle = styled.h2`
	color: '#130F31';
	font-size: 18px;
	font-style: normal;
	font-weight: 590;
	line-height: normal;
`;

export const CardSubTitle = styled.p`
	color: '#636172';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
`;

export const CardFooter = styled.footer`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	typeLink: 'PAUSE' | 'RESUME' | 'FINALIZED';
	isLoading?: boolean;
}

export const ButtonFooter = styled.button<ButtonProps>`
	background-color: ${({ theme, typeLink }) =>
		typeLink === 'PAUSE'
			? theme.colors.extra.saturn_500
			: typeLink === 'RESUME'
			? theme.colors.extra.success_500
			: theme.colors.extra.error_500};
	border: none transparent;
	border-radius: 4px;
	color: #fff;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	height: 48px;
	transition: 0.2s ease-in-out scale, opacity;
	width: 100%;

	&:active {
		opacity: 0.8;
		scale: 1.05;
	}

	&:hover {
		opacity: 0.8;
		scale: 1.05;
	}
`;
